const NEXT_MAJOR_PROTOCOL_VERSION = 11;
type MAJOR_PROTOCOL_VERSION = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
export type ProtocolVersion = [MAJOR_PROTOCOL_VERSION, number | bigint];
